import { render, staticRenderFns } from "./bdStructureMaterialTable.vue?vue&type=template&id=1dffbce2"
import script from "./bdStructureMaterialTable.vue?vue&type=script&lang=js"
export * from "./bdStructureMaterialTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./bdStructureMaterialTable.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports